

$(document).ready(function() {
    // When the user hovers over the container of the disabled input
    $('.tooltip-container').mouseenter(function() {
        // Get the tooltip text from data-tooltip attribute of the input
        var tooltipText = $(this).find('.tooltip').data('tooltip');

        // Set the content of the tooltip-text element
        $(this).find('.tooltip-text').text(tooltipText);

        // Show the tooltip
        $(this).find('.tooltip-text').css({
            'visibility': 'visible',
            'opacity': '1'
        });
    });

    // When the user moves the mouse out of the container
    $('.tooltip-container').mouseleave(function() {
        // Hide the tooltip
        $(this).find('.tooltip-text').css({
            'visibility': 'hidden',
            'opacity': '0'
        });
    });
});
